export default __webpack_public_path__ + "static/media/Thug's Gloves of Arcane Death.eb6da843.jpg";